import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { useRoutes } from 'react-router';
import { ROUTES } from 'routes';

import Main from 'components/Main';

import AppQuery, {
  AppQuery as AppQueryType,
} from '__generated__/AppQuery.graphql';

type Props = {
  preloadedQuery: PreloadedQuery<AppQueryType>;
};

const Router: FC<Props> = props => {
  const data = usePreloadedQuery<AppQueryType>(AppQuery, props.preloadedQuery);

  const app = useRoutes([
    {
      path: '/',
      element: <Main data={data} />,
      children: ROUTES,
    },
  ]);

  return app;
};

export default Router;
